<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Invite Customer to Event</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <ng-container *ngIf="loadingEvent">
        <p class="text-muted">Loading event...</p>
      </ng-container>
      <ng-container *ngIf="!loadingEvent && event">

        <p class="mb-0">
          Event Type: <b>{{ event.event_type_name }}</b> <br>
          Location: <b>{{ event.location_name }}</b>
        </p>

        <ng-container *ngIf="event.event_parts.length === 1">
          <p class="mb-0">
            Time:
            <b>
              {{ event.event_parts[0].start_local_date }},
              {{ event.event_parts[0].start_local_time }} -
              {{ event.event_parts[0].end_local_time }}
            </b>
          </p>
        </ng-container>
        <ng-container *ngIf="event.event_parts.length > 1">
          <p class="mb-1">Multi-part event:</p>
          <ul class="mb-0">
            <li *ngFor="let eventPart of event.event_parts">
              <b>
                {{ eventPart.start_local_date }},
                {{ eventPart.start_local_time }} -
                {{ eventPart.end_local_time }}
              </b>
            </li>
          </ul>
        </ng-container>
      </ng-container>
    </div>

    <div class="form-group">
      <ng-container *ngIf="selectedCustomerId === null">
        <div>
          <button type="button" class="btn btn-sm btn-outline-primary mr-2"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave"
                  (click)="openSelectCustomerModal()">
            Search for Customer
          </button>
          <button type="button" class="btn btn-sm btn-outline-primary"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave"
                  (click)="openCreateCustomerModal()">
            Create New Customer
          </button>
        </div>
        <small class="form-text text-muted">
          Customers who are already on the participant list or active waitlist for this event are excluded.
        </small>
      </ng-container>
      <ng-container *ngIf="selectedCustomerId !== null">
        <p class="mb-0">
          <b>{{ selectedCustomerName }}</b>
          <button type="button" class="btn btn-sm btn-link ml-2 p-0"
                  style="vertical-align: baseline"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave"
                  (click)="clearSelectedCustomer()">
            Clear Selection
          </button>
        </p>
      </ng-container>
    </div>

    <app-age-restriction-bypass-warning [violations]="ageRestriction.violations"
                                        [(acknowledged)]="ageRestriction.acknowledged"
                                        [disabled]="loadingSave"></app-age-restriction-bypass-warning>

    <app-invite-expiry-input [idPrefix]="'inviteToEvent'"
                             [(expiry)]="expiry"
                             [timeZone]="expiryTimeZone()"
                             [disabled]="loadingSave"></app-invite-expiry-input>

    <div class="form-group">
      <label>Invite Note (optional)</label>
      <app-markdown-editor [id]="'inviteNote'"
                           [(content)]="inviteNote"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        This text will be included in the invite, underneath information about the event and (if configured above) the booking deadline.
      </small>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               id="sendInviteToParentsAndGuardians"
               name="sendInviteToParentsAndGuardians"
               [disabled]="loadingSave"
               [class.disabled]="loadingSave"
               [(ngModel)]="sendInviteToParentsAndGuardians">
        <label class="form-check-label"
               for="sendInviteToParentsAndGuardians">
          Send invite to linked parents &amp; guardians
        </label>
      </div>
      <small class="form-text text-muted">
        If selected, the invite will be sent to any linked parents and guardians of the participant to accept or reject the invite on behalf of the participant. This is in addition to the participant's own email address.
      </small>
    </div>

    <ng-container *ngIf="loadingSave">
      <h4>Loading...</h4>
    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="alert alert-warning" role="alert"
         *ngIf="scheduledEvent.remaining_capacity <= 0">
      This event has no remaining capacity. By sending this invite, you will bypass the capacity limit, and if the invite is accepted, the event will go over capacity.
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSave"
            [disabled]="!sendInviteAllowed()"
            [class.disabled]="!sendInviteAllowed()"
            (click)="handleSendInvite()">
      Send Invite
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
